import { Action } from "redux";

export type CreatedJiraTicketSuccessEvent = Action<typeof CREATED_JIRA_TICKET_SUCCESSFULLY>

const createdJiraTicketSuccessfully = () => ({
  type: CREATED_JIRA_TICKET_SUCCESSFULLY
});

export const CREATED_JIRA_TICKET_SUCCESSFULLY = "created_jira_ticket_successfully";

export default createdJiraTicketSuccessfully;